import React from 'react';
import { Link } from 'react-router-dom';
import './ISO22483.css';

const ISO22483 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 22483 Tourism Quality Management System</h1>
            <h2 className="page-subtitle">High Quality Standards in Tourism with ISO 22483</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we are providing a comprehensive review of 
                the ISO 22483 Tourism Quality Management System to elevate quality standards in the 
                tourism sector.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 22483?</h2>
            <div className="page-text-content">
              <p>
                ISO 22483 is a specialized quality management system designed specifically for the 
                tourism sector. This international standard aims to enhance the quality of tourism 
                services and help businesses achieve sustainable success. ISO 22483 is particularly 
                important for businesses operating in the tourism sector, including accommodations, 
                food and beverage services, entertainment, and other tourist services.
              </p>
              <p>
                ISO 22483 guides businesses in improving customer satisfaction, embracing sustainability, 
                ensuring business continuity, and promoting staff training. The standard reinforces 
                businesses' commitment to providing quality services and gaining competitive advantages.
              </p>
              <p>
                For businesses in the tourism sector, ISO 22483 emphasizes the importance of focusing 
                on customer satisfaction, environmental and social responsibilities, crisis preparedness, 
                and staff development. The certification helps businesses demonstrate their adherence 
                to international standards, adopt best practices, and provide high-quality, reliable, 
                and sustainable tourism experiences.
              </p>
              <p>
                ISO 22483 encourages businesses to adopt continuous improvement principles and 
                customer-centric approaches, ensuring that tourism services meet internationally 
                recognized quality standards.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Elements of ISO 22483:</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">1. Customer-Centric Service</h3>
                <p className="element-description">
                  ISO 22483 recommends that tourism businesses organize their services in a 
                  customer-centric manner to maximize customer satisfaction.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">2. Sustainability</h3>
                <p className="element-description">
                  The standard emphasizes the importance of sustainability in tourism activities and 
                  encourages businesses to develop solutions to reduce their environmental impacts.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">3. Business Continuity</h3>
                <p className="element-description">
                  As the tourism sector often experiences variability, ISO 22483 supports businesses 
                  in planning and implementing business continuity measures.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">4. Training and Development</h3>
                <p className="element-description">
                  ISO 22483 encourages continuous training and development of staff to enhance service 
                  quality.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 22483 and Quality in Tourism:</h2>
            <div className="page-text-content">
              <p>
                The ISO 22483 certification provides several advantages to tourism businesses:
              </p>
            </div>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Customer Trust</h3>
                <p className="advantage-description">
                  ISO 22483 certified businesses demonstrate their commitment to providing high-quality 
                  and reliable experiences to customers.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Competitive Advantage</h3>
                <p className="advantage-description">
                  The standard provides businesses with an opportunity to stand out from other 
                  competitors in the industry.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Innovation and Development</h3>
                <p className="advantage-description">
                  ISO 22483 supports businesses in their continuous improvement and innovation efforts, 
                  enabling them to lead the industry.
                </p>
              </div>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO22483;

